<template>
     <div class="success-boxs fix">
       <div class="left-column"><img src="../assets/404.png" alt="404"></div>
       <div class="panel">
         <h4 class="title"><span>抱歉！您访问的页面打不开了，原因可能如下：</span></h4>
         <div class="option" >
            <p>- 页面不存在、或已被删除、或丢失</p>
            <p>- 访问网速太慢或网络中断</p>
            <p>- 同时访问这个页面的人太多</p>
            <p>- 系统升级更新中</p>
          </div>
         <h4 class="title top10"><span>您可以进行以下操作：</span></h4>
         <div class="option" >
          <a href="" @click="onGo">返回上一页</a>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  methods:{
    onGo(){
      this.$router.go(-1)
    }
  }
}
</script>
<style>
.success-boxs {
  padding: 100px;
  margin: 0 auto;
  width: 1200px;
  text-align: center;
}
.success-boxs .left-column {
  width: 550px;
  margin-right: 50px;
  height: 200px;
  text-align: right;
  float: left;
}
.success-boxs .panel {
  float: left;
  width: 412px;
  color: #333;
  text-align: left;
}
.success-boxs .panel .title {
  font-size: 16px;
  line-height: 26px;
  margin-top: 30px;
  color: #666;
}
.success-boxs .panel .top10 {
  margin-top:10px;
}
.success-boxs .option {
  padding: 10px 0 10px;
}
.success-boxs .option a {
  color: #f60;
}
.success-boxs strong {
  color: #e42900;
  font-weight: 700;
}
</style>
